export default __webpack_public_path__ + "static/media/fol_f0.9d702279.png";